module.exports = __webpack_public_path__ + "img/Ausrilabs.4613de7c.jpg";